import {
  Component, OnInit, AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { AuthenticationService } from "../services/authentication.service";
import Swal from 'sweetalert2'
import { StripeToken, StripeSource } from "stripe-angular";
import { NgForm } from "@angular/forms";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
declare var stripe: any;

@Component({
  selector: 'app-banner-ads-list',
  templateUrl: './banner-ads-list.component.html',
  styleUrls: ['./banner-ads-list.component.css']
})
export class BannerAdsListComponent implements OnInit {
  public bannerAds: any;
  spinnerType = SPINNER.circle;
  public user: any;
  activeTab ="create";

  @ViewChild("cardInfo") cardInfo: ElementRef;

  allPlans: Array<any> = [];
  bannerSizePlans: Array<any> = [];
  loading = false;
  personalDetails!: FormGroup;
  addressDetails!: FormGroup;
  educationalDetails!: FormGroup;
  personal_step = false;
  address_step = false;
  education_step = false;
  step = 1;
  selectBannerPlan: string;

  card: any;
  public invalidError: any;
  // cardHandler = this.onChange.bind(this);
  error: string;
  defaultCard: string;
  showSpinner: Boolean = true;
  enablePromo: Boolean = false;
  isCouponValid: Boolean = false;
  copuonAppliedMsg: string = "";
  discount: any = 0;
  coupon: string = "";
  couponApplied: Boolean = false;
  checkBannerSize:any
  captionType:any;
  public cards = [];
  amount: any = 0;
  loadingMsg: string = "Loading ...";
  public plan: any;
  public form: FormGroup;
  public range: any;
  public cardId: any;
  subscriptionId: any = '';
  public isCouponApplied: any;
  isBannerPlan = false;
  isBannerSizePlan = false;
  cardReady = false;
  userBasicBannerPlan: any;
  bannerPlanType: any;
  bannerSizePlanType: any;
  myBannerPlan: any;
  myBannerPlans: any;
  subscription:any;
  total = 0;
  bannerPrice = 0;
  bannerSizePrice = 0;
  selectedSubscriptionPlan: any;
  isDiscount:any;
  planName:any;
  planList:any
  bannerSize: any;
  images = {
    fullWidth: 'assets/Business Banner Template-Full.jpg',
    halfWidth: 'assets/Business Banner Template-Half.jpg',
    oneThirdWidth: 'assets/Business Banner Template-Third.jpg',
  };
  bannerSizePlanss = [
    {  bannerSize: 'Full width' },
    {  bannerSize: 'Half width' },
    {  bannerSize: '1/3 width' },
  ];
  selectedBannerSize: string = '';
  constructor(
    public fb: FormBuilder,
    private ngxService: NgxUiLoaderService,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private modalService: NgbModal

  ) {
    this.route.queryParams.subscribe((params) => {
      this.subscriptionId = params.id;
    })
  }
  ngOnInit(): void {
    this.subscriptionPlans();
    this.getProfile();
    // this.getUserProfile();
    this.getBannerAdsListing();
  }





  public getBannerAdsListing(): void {
    this.ngxService.start();
    let skip = 0;
    let limit = 10000;
    this.authenticationService.getBannerAds(skip, limit).subscribe(
      (response: any) => {
        console.log("response>>>>>>>>>>>>>>>>", response);
        this.ngxService.stop();
        this.bannerAds = response['items'];
      },
      (error) => {
        this.ngxService.stop();
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }
  delete(id: any) {
    console.log("delete id", id);
    var result = confirm('Do you wnat to cancel your banner plan to stop recurring charges?');
    if (result) {
      this.authenticationService.deleteBannerAd(id).subscribe(
        (response: any) => {
          this.ngxService.stop();
          this.getBannerAdsListing();
        },
        (error) => {
          this.ngxService.stop();
          if (error) {
            Swal.fire('Error', error.error.message, 'error');
          }
        }
      );
    }
  }
  edit(data:any){
    this.router.navigate(['/add-banner-ads'], { queryParams: { id: data._id, label:data.offerLocation} });
  }
  checkImage(usr) {
    return environment.basePath + usr;
    // if (usr) {
    //   let pathArray = usr.split('/');
    //   let protocol = pathArray[0];
    //   let host = pathArray[2];
    //   let url = protocol + '//' + host + '/';
    //   if (url == environment.basePath) {
    //     return usr;
    //   } else {
    //     return environment.basePath + usr;
    //   }
    // }
  }
  redirect(type) {
    if (type == 1) {
      if (this.user.hasSubscription == true) {
        this.router.navigate(['/add-advertisement']);
      } else {
        Swal.fire('Error', 'Please subscribe base plan.', 'error');
      }
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
  getUserProfile(): void {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.user = response.data;
        if(this.user && this.user?.bannerPlanType?.length == 0) {
          this.authenticationService.deleteBanner().subscribe(
            (response: any) => {
              this.bannerAds = [];
            },
            (error) => {
            }
          );

        }
      },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }

  createAds(content: any) {
    if (this.bannerPlanType.length && this.bannerAds.length) {
      Swal.fire('Error', 'Please note that adding a second banner is not permitted unless a separate banner plan is purchased.', 'error');
    } else if(this.bannerPlanType.length && !this.bannerAds.length) {
      this.router.navigate(['/add-banner-ads'], { queryParams: { isPlan: true, label:this.myBannerPlans[0]?.caption } });
    } else {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    }
  }


  goToSubscribe() {
    this.activeTab = "create"
    this.modalService.dismissAll()
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
    this.modalService.dismissAll()
  }

  getDate(date) {
    return moment(date).format('DD-MM-YYYY')
  }
  redirectImage(url:any) {
    let path = environment.basePath + url;
    window.open(path, '_blank');
  }
  getScrollTo(id: string) {
    this.activeTab = id;
    const element = this.getElementById(id);
  }
  getElementById(id: string): HTMLElement {
    const element = <HTMLElement>document.querySelector(`#${id}`);
    return element;
  }
  next(planType: string) {
    localStorage.removeItem('planDetail')
    if(this.subscription && this.subscription?.length > 0 && this.subscription[0]?.amount == 0 || !this.subscription?.length) {
      return Swal.fire({
        title: "Oops...",
        html: "To create Ads or a Business Banner,<br>please upgrade to a paid plan",
        icon: "error"
      });
    }
    if(this.myBannerPlans && this.myBannerPlans.length) {
      return Swal.fire(
        "Oops...",
        "You are already subscribed to the banner plan. Please cancel your subscription to proceed.",
        "error"
      )
    }
    if (!this.isBannerPlan) {
      return Swal.fire({
        title: "Choose Banner Plan",
        icon: 'error'
      });
    }

    if (!this.isBannerSizePlan) {
      return Swal.fire({
        title: "Choose Banner Size Plan",
        icon: 'error'
      });
    }
    const plan = this.planList.filter((val=>val.caption == this.captionType && val.price == this.total));
    localStorage.setItem('planDetail', JSON.stringify(plan[0]))
      this.router.navigate(['/add-banner-ads'], { queryParams: { bannerPlanId: plan[0]._id, isDiscount:this.isDiscount, label: this.captionType} });
  }


reNewPlan(id:any){
  console.log("value of plan is",id)
  this.selectBannerPlan=id
  //  this.router.navigate(['/base-payment'], { queryParams: { bannerPlanId: this.selectBannerPlan, bannerSizeId:this.selectedSubscriptionPlan, isBannerPlan:isBannerPlan, isBannerSizePlan:isBannerSizePlan } });
  this.router.navigate(['/base-payment'], { queryParams: { bannerPlanId: id } });


}

  subscriptionPlans(): void {
    this.spinner.show();
    this.authenticationService.getBannerPlans().subscribe(
      (response: any) => {
        console.log(response.data, "resss")
        this.planList = response?.data;
        const uniqueBannerPlans = this.getUniqueObjects(response?.data, 'visibiltyPrice');
        const uniqueBannerSize = this.getUniqueObjects(response?.data, 'bannerSizePrice');
        const bannerSizee = this.getUniqueObjects(response?.data, 'bannerSize');
        this.bannerSizePlans = uniqueBannerSize
        this.bannerSize = bannerSizee;
        this.allPlans = uniqueBannerPlans;
        this.allPlans = this.allPlans.filter(val => val.caption !== "Business Quarterly");
        this.allPlans = this.allPlans.sort((a, b) => a.visibiltyPrice.localeCompare(b.visibiltyPrice));

        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }


  downloadTemplate(bannerSize: any) {

    let imagePath = '';

    if (this.selectedBannerSize === 'Full width') {
      imagePath = this.images.fullWidth;
    } else if (this.selectedBannerSize === 'Half width') {
      imagePath = this.images.halfWidth;
    } else if (this.selectedBannerSize === '1/3 width') {
      imagePath = this.images.oneThirdWidth;
    }

    // After the loop, check if a valid imagePath was found
    if (imagePath) {
      const link = document.createElement('a');
      link.href = imagePath;
      link.download = imagePath.split('/').pop() || 'template.jpg';
      link.click();
    } else {
      console.error("No valid banner size found for downloading.");
    }
  }



  getUniqueObjects(arr, prop) {
    return arr.filter((obj, index, self) =>
      index === self.findIndex((o) => o[prop] === obj[prop])
    );
  }
  convertSubscripitonType(days) {
    if (days === 365) {
      return "Yearly"
    } else if (days === 30) {
      return "Monthly"
    } else if (days === 90) {
      return "Quarterly"
    }
    else if (days === 180) {
      return "Half Yearly"
    }
    return "Days"
  }

  changeBannerPlans(value: any, action: any) {
    if (action === 'size') {
      this.selectedBannerSize = value.bannerSize; // Store selected size
    }
    this.selectedSubscriptionPlan = value?._id;
    if (action === 'banner') {
      this.captionType = value.caption;
      this.bannerPrice = value?.visibiltyPrice;
      this.isBannerPlan = true;

    } else if (action === 'size') {
      this.bannerSizePrice =  value?.bannerSizePrice;
      this.isBannerSizePlan = true;
    }
    this.total = this.bannerPrice+this.bannerSizePrice;
  }

  getProfile() {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        if (response && response?.data) {
          console.log("Respose???????????????????", response);
          this.bannerPlanType = response?.data?.bannerPlanType;
          this.myBannerPlans = this.bannerPlanType;
          this.subscription = response?.data.subscriptions
          let checkBannerSize = this.allPlans.filter(val => val.price == this.bannerPlanType[0]?.amount && val.caption == this.bannerPlanType[0].caption);
          this.checkBannerSize = checkBannerSize[0]?.bannerSize;
          this.getPlanById(response?.data?.subscriptionPlanType)
          this.total = this.bannerPrice+this.bannerSizePrice;
          if(response?.data &&response.data?.bannerPlanType?.length == 0) {
            this.authenticationService.deleteBanner().subscribe(
              (response: any) => {
                this.bannerAds = [];
              },
              (error) => {
              }
            );

          }
        }
      },
      (error) => {
        console.error(error)
      }
    )
  }





  getPlanById(id:any) {
    this.authenticationService.getPlanById(id).subscribe(
      (response: any) => {
        if (response && response?.data) {
          this.planName = response?.data?.caption
          if(response.data.caption == "Founder" || response.data.caption ==  "Community Builder"){
            this.isDiscount = 'true';
          }
        }
      },
      (error) => {
        console.error(error)
      }
    )

  }
  isSubscribedToBannerSizePlan(): boolean {
    return this.myBannerPlans?.some(plan => plan.type === 'bannerSize' && plan.isActive && plan.isPaid);
  }

  isSubscribedToBannerPlan(): boolean {
    return this.myBannerPlans?.some(plan => plan.type === 'basic' && plan.isActive && plan.isPaid);
  }

  cancelSubscription(id: String) {
    Swal.fire({
      title: 'Are you sure you want to Cancel your Subscription?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.authenticationService.cancelBannerSubscription(id).subscribe(
          (response: any) => {
            console.log(response, 'response1234')
            if (response?.code === 200) {
              if(this.bannerAds.length) this.delete(this.bannerAds[0]._id)
              if(this.selectBannerPlan == id) this.selectBannerPlan = ''
              if(this.selectedSubscriptionPlan == id) this.selectedSubscriptionPlan = ''
              Swal.fire({
                title: "Subscription Cancelled Successfully",
                icon: 'success'
              })
              setTimeout(()=>{                           // <<<---using ()=> syntax
                window.location.reload();
                this.getProfile();
            }, 3000);

            }
            console.log("ressssss", response);
          },
          (error) => {
            console.error(error)
          }
        )
      }
    })
  }
}
